export default __webpack_public_path__ + "static/media/tqicon-8.97d63f0f.svg";